var _rect, _rect2, _rect3, _ellipse, _ellipse2, _path, _path2, _path3, _rect4, _text, _text2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLetsgosaunaNavbar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 108 44",
    width: 108,
    height: 44,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 30,
    width: 28,
    height: 4,
    rx: 1.5,
    fill: "#C8622A"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 36,
    width: 28,
    height: 4,
    rx: 1.5,
    fill: "#9B3E15"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 24,
    width: 24,
    height: 4,
    rx: 1.5,
    fill: "#C8622A"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 22,
    cy: 20,
    rx: 7,
    ry: 4,
    fill: "#E87B30"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 19,
    cy: 18,
    rx: 3,
    ry: 2,
    fill: "#B24E10",
    opacity: 0.7
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 15 Q14.5 10 16 5",
    fill: "none",
    stroke: "#C8622A",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 14 Q20.5 8 22 3",
    fill: "none",
    stroke: "#C8622A",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28 15 Q26.5 10 28 5",
    fill: "none",
    stroke: "#C8622A",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 28,
    width: 7,
    height: 12,
    rx: 1.5,
    fill: "#7A2E0A"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 42,
    y: 20,
    fontFamily: "Georgia, 'Times New Roman', serif",
    fontSize: 15,
    fontWeight: 700,
    fill: "#1A1008",
    letterSpacing: 0.3
  }, "Let's Go")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 42,
    y: 38,
    fontFamily: "Georgia, 'Times New Roman', serif",
    fontSize: 13,
    fontWeight: 700,
    fill: "#1A1008",
    letterSpacing: 3
  }, "SAUNA")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLetsgosaunaNavbar);
export default __webpack_public_path__ + "static/media/letsgosauna-navbar.c7227a1773e7a709c44936531dd259ba.svg";
export { ForwardRef as ReactComponent };